module.exports = __webpack_public_path__ + "media/dashboard/assets/images/contact-socials/facebook-65ade1b197d6429a2b6922f25c0133df.svg";